import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, 
         DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwActionPreference, DwFormActionConfig, 
         DwFormActionInterceptResult, DwMessageSeverity,
         DwMessagingService, DwOrmDataService, DwOrmDataServiceToken, DwFormActionInterceptor } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataService } from '../../../meta-data/app-meta-data.service';
import { FleetVehicleEntity, FleetMetaDataItemNames } from '../meta-data/fleet-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent({
  name: 'Fleet Vehicle UI Util',
  key: 'fleetVehicleUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: FleetMetaDataItemNames.FleetVehicle,
})
@Component({
  selector: 'fleet-vehicle-ui-util',
  template: ` 
  `
})
export class FleetVehicleUiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
    formApi: DwMetaDataFormApi;

    constructor(
        dwExpressionService: DwExpressionService,
        private messageService:  DwMessagingService,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private dwMetaDataFormStateService: DwMetaDataFormStateService
    ) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }
  
    ngOnInit(): void {
    }
    setupComponentComplete() {
        this.formApi = this.dwMetaDataFormStateService.state.formApi;

        // this.jobSiteFC = this.getOrCreateFormControl("JobSiteId");
        this.runAfterFormDataLoaded(() => this.setupSubscriptions());

        // Register an action interceptor
        this.dwMetaDataFormStateService.addActionInterceptor(this.getFormActionInterceptor());
    }
    getFormActionInterceptor(): DwFormActionInterceptor {
        return {
            interceptorName: 'fleet-vehicle-save-interceptor',
            onAfterAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any, actionResult: any) => {
                const veh = this.formApi.getFormData<FleetVehicleEntity>();
                if (veh?.SendPaf == true)
                    this.messageService.showMessage({
                            messageHeading: 'Email Sent!', 
                            messageBody: 'PAF Email was successfully sent!', 
                            timeToShow : 3000,
                            severity: DwMessageSeverity.success 
                    });
                return of({ abort: false });
            },
        };
      }
    
    private setupSubscriptions() {
        this.subscriptions.push(this.formApi.getFormDataChanges<FleetVehicleEntity>(200).subscribe(entity => {
            this.handleUpdate(entity);
        }));
    }
    ngOnDestroy(): void {
        for(const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    } 

    private isNumeric = (val: string) : boolean => !isNaN(Number(val));
    handleUpdate(veh: FleetVehicleEntity) { 
        if (this.formApi == undefined || veh == undefined) return;

        //when the amount entered in the 'GVWR' field is 10,001 or greater - or manually)
        if (this.isNumeric(veh.GVWR) && Number(veh.GVWR) >= 10001 && veh.IsDot != true)
            this.formApi.patchFormData({ IsDot: true });
    }
}
